var _defs, _rect, _rect2, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileActivateExpressCheckoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.069,
    y1: -0.147,
    x2: 0.84,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35528",
    "data-name": "Group 35528",
    transform: "translate(-21 -302)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5513",
    "data-name": "Rectangle 5513",
    width: 71,
    height: 71,
    rx: 35.5,
    transform: "translate(21 302)",
    fill: "#fc3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35543",
    "data-name": "Group 35543",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5513-2",
    "data-name": "Rectangle 5513",
    width: 71,
    height: 71,
    rx: 35.5,
    transform: "translate(21 302)",
    fill: "url(#linear-gradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_39563",
    "data-name": "Path 39563",
    d: "M35.5,0A35.5,35.5,0,1,1,0,35.5,35.5,35.5,0,0,1,35.5,0Z",
    transform: "translate(21 302)",
    fill: "url(#linear-gradient)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35596",
    "data-name": "Group 35596",
    transform: "translate(39 320)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39513",
    "data-name": "Path 39513",
    d: "M5.2,24.4A3.2,3.2,0,1,0,2,21.2,3.2,3.2,0,0,0,5.2,24.4Z",
    transform: "translate(0 9.6)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39514",
    "data-name": "Path 39514",
    d: "M16.2,24.4A3.2,3.2,0,1,0,13,21.2,3.2,3.2,0,0,0,16.2,24.4Z",
    transform: "translate(6.6 9.6)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39515",
    "data-name": "Path 39515",
    d: "M9.2,6.8,12.4,2H6",
    transform: "translate(2.4)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39516",
    "data-name": "Path 39516",
    d: "M21.6,20.4H4l3.2-6.389",
    transform: "translate(1.2 7.204)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39517",
    "data-name": "Path 39517",
    d: "M9.2,5H31.6L26.8,19.4H6",
    transform: "translate(2.4 1.8)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_502",
    "data-name": "Line 502",
    x2: 12.8,
    transform: "translate(5.2 11.6)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_503",
    "data-name": "Line 503",
    x2: 12.8,
    transform: "translate(2 16.4)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileActivateExpressCheckoutIcon);
export default __webpack_public_path__ + "static/media/profile-activate-express-checkout-icon.afce29dbed2591cb74a5c2a86825c587.svg";
export { ForwardRef as ReactComponent };